module.exports = __webpack_public_path__ + "static/media/PK.ca3b7160.svg";